import { createContext } from 'react';
import { FakeSOSocket, SafeDatabaseUser } from '../types/types';

/**
 * Interface represents the context type for user-related data and a WebSocket connection.
 *
 * - user - the current user.
 * - socket - the WebSocket connection associated with the current user.
 * - updateUser - function to update the user data in the context.
 */
export interface UserContextType {
  user: SafeDatabaseUser;
  socket: FakeSOSocket;
  updateUser: (userData: Partial<SafeDatabaseUser>) => void;
}

const UserContext = createContext<UserContextType | null>(null);

export default UserContext;
